<fieldset class="rounded-1 w-fit shadow-md p-2 border border-neutral-400 {{hasError() ? 'bg-red-100' : ''}}">
  <legend class="text-neutral-800 text-xs">{{label()}}</legend>
  <div class="overflow-hidden w-24 h-24 flex items-center justify-center">
    @if(isLoading()) {
      <div class="animate-spin rounded-full h-8 w-8 border-4 border-neutral-300 border-t-blue-600"></div>
    } @else if(hasError()) {
      <div class="flex flex-col items-center justify-center">
        <svg class="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
        </svg>
        <p class="text-xs text-red-500 mt-1">خطا در بارگذاری</p>
      </div>
    } @else if(imageSrc()) {
      <img 
        [src]="imageSrc()" 
        (error)="onImageError()" 
        (click)="toggleExpand()" 
        width="96" 
        height="96" 
        class="cursor-pointer object-cover w-full h-full"
      />
    } @else {
      <div class="flex justify-center items-center w-full h-full">
        <p class="text-xs text-neutral-500">بدون عکس</p>
      </div>
    }
  </div>
</fieldset>

@if(isExpanded() && imageSrc() && !isLoading()) {
<div 
  class="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
  (click)="toggleExpand()"
>
  <div class="relative max-w-[90vw] max-h-[90vh]">
    <img 
      [src]="imageSrc()" 
      class="w-auto h-auto max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
      alt="{{label()}}"
    />
    <button 
      class="absolute top-2 right-2 text-white bg-black/50 rounded-full w-8 h-8 hover:bg-black/70 transition-colors"
      (click)="$event.stopPropagation(); toggleExpand()"
    >
      ✕
    </button>
  </div>
</div>
}